import Button from "../../../../../lib/html5-software-library/src/ranj/components/buttons/Button";
import { capitalize } from "../../../../../lib/html5-software-library/src/ranj/util/StringUtil";

export default class MapLocationButton extends Button {
    constructor(skin) {
        super(skin);

        this.skin.locationLabel.alpha = 0;
    }

    setLabel(string) {
        super.setLabel(string);

        for (let i = 0; i < Button.TEXTFIELDNAMES.length; i++) {
            let textField = this.skin.locationLabel[Button.TEXTFIELDNAMES[i]];
            if (textField) {
                textField.text = this._label ? this._label : "";
                if (this._wordWrap) {
                    this._applyWordWrap(textField);
                }
            }
        }
    }

    setSelected(value) {
        super.setSelected(value);

        if (!value) {
            this._hideLabel();
        }
    }

    _showLabel() {
        createjs.Tween.get(this.skin.locationLabel, { override: true })
            .to({ alpha: 1 }, 150, createjs.Ease.sineInOut);
    }

    _hideLabel() {
        createjs.Tween.get(this.skin.locationLabel, { override: true })
            .to({ alpha: 0 }, 150, createjs.Ease.sineInOut);
    }

    _handleRollOver(evt) {
        super._handleRollOver(evt);

        this._showLabel();
    }

    _handleRollOut(evt) {
        super._handleRollOut(evt);

        if (this.getSelected()) {
            return;
        }

        this._hideLabel();
    }

    _setState(state) {
        super._setState(state);


        this._setStateForImage(state);
        this._setStateForLabel(state);
    }

    _setStateForImage(state) {
        let newState = state;
        if (this.getSelected()) {
            newState = "selected" + capitalize(newState);
        }
        
        this.skin.locationImage.gotoAndStop(newState);
    }

    _setStateForLabel(state) {
        this.skin.locationLabel.gotoAndStop(state);

        for (let i = 0; i < Button.TEXTFIELDNAMES.length; i++) {
            let textField = this.skin.locationLabel[Button.TEXTFIELDNAMES[i]];
            if (textField) {
                textField.visible = false;
            }
        }

        const activeTextField = this.skin.locationLabel[state + "LabelTextField"];
        if (activeTextField) {
            activeTextField.visible = true;
        }
    }
}